import type {
  DehydratedState,
  VueQueryPluginOptions,
} from "@tanstack/vue-query";
import {
  VueQueryPlugin,
  QueryClient,
  hydrate,
  dehydrate,
} from "@tanstack/vue-query";
import { experimental_createPersister } from "@tanstack/query-persist-client-core";
// Nuxt 3 app aliases
import { defineNuxtPlugin, useState } from "#imports";

export default defineNuxtPlugin((nuxt) => {
  const vueQueryState = useState<DehydratedState | null>("vue-query");

  // Modify your Vue Query global settings here
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5000,
        gcTime: 30000,
        /* @ts-ignore */
        // Strange type error, but it works
        // persister: experimental_createPersister({
        //   storage: {
        //     getItem: (key: string) => {
        //       if (import.meta.client) {
        //         return localStorage.getItem(key);
        //       }
        //       return null;
        //     },
        //     setItem: (key: string, value: string) => {
        //       if (import.meta.client) {
        //         localStorage.setItem(key, value);
        //       }
        //     },
        //     removeItem: (key: string) => {
        //       if (import.meta.client) {
        //         localStorage.removeItem(key);
        //       }
        //     },
        //   },
        //   maxAge: 1000 * 60 * 60 * 12,
        // }),
      },
    },
  });
  const options: VueQueryPluginOptions = { queryClient };

  nuxt.vueApp.use(VueQueryPlugin, options);

  if (import.meta.server) {
    nuxt.hooks.hook("app:rendered", () => {
      vueQueryState.value = dehydrate(queryClient);
    });
  }

  if (import.meta.client) {
    hydrate(queryClient, vueQueryState.value);
  }
});
